import { Box, BoxProps, Modal, ModalOverlay } from '@chakra-ui/react';
import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

export const Overlay: React.FC<Props & BoxProps> = ({ children, ...props }) => {
  return (
    <Modal isOpen={true} onClose={() => {}} size="full">
      <ModalOverlay>
        <Box
          position="fixed"
          top="0"
          left="0"
          width="100%"
          height="100%"
          overflow="auto"
          // TODO: replace with zIndex const
          zIndex={100}
          {...props}
        >
          {children}
        </Box>
      </ModalOverlay>
    </Modal>
  );
};
